// Shared by Cloud Functions and the frontend (imported there as @shared).
// Season awards and the league record book: names, and how each record is
// measured and shown. The server works them out when a season is archived
// (src/league/awards.js, src/league/records.js).

export const AWARDS = [
  {key: "poy", label: "Player of the Year"},
  {key: "opoy", label: "Offensive Player of the Year"},
  {key: "dpoy", label: "Defensive Player of the Year"},
  {key: "sixth", label: "Sixth Player of the Year"},
];

// How many entries each record list keeps.
export const RECORDS_KEPT = 10;

// kind: "total" (season total of `stats` summed), "avg" (per game),
// "pct" (made / att, with at least minAtt attempts per game) or "game"
// (best single game).
export const RECORD_CATEGORIES = [
  {key: "pts", group: "Season totals", label: "Points", kind: "total",
    stats: ["pts"]},
  {key: "reb", group: "Season totals", label: "Rebounds", kind: "total",
    stats: ["oreb", "dreb"]},
  {key: "ast", group: "Season totals", label: "Assists", kind: "total",
    stats: ["ast"]},
  {key: "tpm", group: "Season totals", label: "3-pointers", kind: "total",
    stats: ["tpm"]},
  {key: "stl", group: "Season totals", label: "Steals", kind: "total",
    stats: ["stl"]},
  {key: "blk", group: "Season totals", label: "Blocks", kind: "total",
    stats: ["blk"]},
  {key: "ppg", group: "Per game", label: "Points per game", kind: "avg",
    stats: ["pts"]},
  {key: "rpg", group: "Per game", label: "Rebounds per game", kind: "avg",
    stats: ["oreb", "dreb"]},
  {key: "apg", group: "Per game", label: "Assists per game", kind: "avg",
    stats: ["ast"]},
  {key: "spg", group: "Per game", label: "Steals per game", kind: "avg",
    stats: ["stl"]},
  {key: "bpg", group: "Per game", label: "Blocks per game", kind: "avg",
    stats: ["blk"]},
  {key: "fgPct", group: "Shooting", label: "Field goal %", kind: "pct",
    made: "fgm", att: "fga", minAtt: 5},
  {key: "tpPct", group: "Shooting", label: "3-point %", kind: "pct",
    made: "tpm", att: "tpa", minAtt: 2},
  {key: "ftPct", group: "Shooting", label: "Free throw %", kind: "pct",
    made: "ftm", att: "fta", minAtt: 2},
  {key: "gamePts", group: "Single game", label: "Points in a game",
    kind: "game", stats: ["pts"]},
  {key: "gameReb", group: "Single game", label: "Rebounds in a game",
    kind: "game", stats: ["oreb", "dreb"]},
  {key: "gameAst", group: "Single game", label: "Assists in a game",
    kind: "game", stats: ["ast"]},
  {key: "gameTpm", group: "Single game", label: "3-pointers in a game",
    kind: "game", stats: ["tpm"]},
  {key: "gameStl", group: "Single game", label: "Steals in a game",
    kind: "game", stats: ["stl"]},
  {key: "gameBlk", group: "Single game", label: "Blocks in a game",
    kind: "game", stats: ["blk"]},
];

/**
 * @param {object} cat a RECORD_CATEGORIES entry
 * @param {number} value
 * @return {string}
 */
export function formatRecord(cat, value) {
  if (cat.kind === "pct") return `${(value * 100).toFixed(1)}%`;
  if (cat.kind === "avg") return value.toFixed(1);
  return String(Math.round(value));
}
